/**
 * Facebook Pixel utilities class
 */
export class FbqUtil {

    public static fbqEvent(action: string, content_ids: string[], content_type: string): void {
        if ((window as any).fbq === undefined) {
            return undefined;
        }

        fbq('track', action, {
            content_ids: content_ids,
            content_type: content_type,
        });
    }
}
